import React from 'react';
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { ErrorMessage, Field } from 'formik';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import TooltipInfo from '../../common/docs/TooltipInfo';

const MainConfig = () => {
  return (
    <AccordionItem uuid="main-config">
      <AccordionItemHeading>
        <AccordionItemButton>
          <i className={`wb`}></i>
          <strong>Main Configuration</strong>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className="row">
          <div className="col-md-12">
            <CustomInputWithIcon icon="text" required={true}>
              <Field
                name="name"
                className="form-control form-control-sm"
                placeholder="Deployment Setting Name"
                title="Enter Deployment Setting Name"
              />
              <TooltipInfo
                title="Enter Deployment Setting Name of your choice. It should not contain special characters or numbers."
                headerText="Deployment Setting Name"
                showHeader={true}
                showArrow={true}
                append={true}
              />
              <p className="text-danger">
                <ErrorMessage name={'name'} />
              </p>
            </CustomInputWithIcon>
          </div>
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <span className="input-group-text">https://</span>
              <Field
                name="domainName"
                className="form-control form-control-sm"
                placeholder="Domain"
                title="Enter Domain"
              />
            </CustomInputWithIcon>
          </div>
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <span className="input-group-text">https://</span>
              <Field
                name="apiDomainName"
                className="form-control form-control-sm"
                placeholder="API Domain"
                title="Enter API Domain"
              />
            </CustomInputWithIcon>
          </div>
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default MainConfig;
